// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise';
import 'core-js/es6/string';
import 'core-js/es7/array';

import Alerts from 'vue-notification';
import BootstrapVue from 'bootstrap-vue';
import Vue from 'vue';
import { MomentMixin } from '@/_moment';
import '@/config';
import { Backend } from '@/_axios';
import { i18n, loadLang } from '@/_translate';
import VueVirtualScroller from 'vue-virtual-scroller'

import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

import store from '@/store/index';
import App from '@/App';
import router from '@/router';

import AlertsMixin from '@/mixins/AlertsMixin';
import FormErrors from '@/mixins/FormErrors';
import DatePickerMixin from '@/mixins/DatePickerMixin';

loadLang(i18n.locale, true);

Vue.use(BootstrapVue);
Vue.use(Alerts, { componentName: 'Alerts' });
Vue.use(VueVirtualScroller)
Vue.mixin(MomentMixin);
Vue.mixin(AlertsMixin);
Vue.mixin(FormErrors);
Vue.mixin(DatePickerMixin);

Vue.filter('flag', (langKey) => {
  const extraFlags = {
    en: 'gb-eng'
  };
  if (extraFlags[langKey]) {
    return extraFlags[langKey];
  }
  return langKey;
});

/* eslint-disable no-new */
new Vue({
  i18n,
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  store
});
